import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordCountTooltip'
})
export class WordCountTooltipPipe implements PipeTransform {
  transform(value: string, limit: number): string {
    const words = value.split(' ');

    if (words.length > limit) {
      return value; // Display full content if word count is within the limit
    } else {
      return ''; // Empty string will hide the tooltip
    }
  }
}
